module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "part01_hd",
      "role": "doc-part"
    }
  }, [_c('div', {
    staticClass: "partbox"
  }, [_c('h1', {
    staticClass: "h1part",
    attrs: {
      "id": "part01_hd"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page vi",
      "id": "page_vi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page vii",
      "id": "page_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("ACT ONE "), _c('span', {
    staticClass: "heading_break"
  }, [_vm._v("LOST")])])])]), _vm._v(" "), _c('div', {
    staticClass: "inlinegroup"
  }, [_c('img', {
    staticClass: "landscape_100",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "e9781665903363/images/common01.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32edb5bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781665903363/xhtml/part01.vue
// module id = 63
// module chunks = 0